import React from 'react';
import styles from './style.module.css';
import { Link } from 'react-router-dom';

interface CardProps {
    title: string;
    link: string;
    index: number;
}

const Card: React.FC<CardProps> = ({ title, link, index }) => {
    return (
        <div key={index} className={`${styles.card} ${index == 0 && styles.cardTitle}`}>
            <h2>{title}</h2>
            <Link to={link}>Continue</Link>
        </div>
    );
}

export { Card }